'use client';

import Gpay from "@/assets/paymentIcons/gpay";
import PayTM from "@/assets/paymentIcons/paytm";
import Phonepay from "@/assets/paymentIcons/phonepay";
import UPIPay from "@/assets/paymentIcons/upi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import React from "react";
import PaymentButton from "./payment-button";


const UPIPayment = () => {
    return (
        <div>
            <div className="flex justify-center items-center">

                <div className="w-2/4">
                    <Label className="text-gray-500 mb-5 inline-block"> Pay with UPI ID</Label>
                    <Input placeholder="Enter UPI"></Input>

                    <PaymentButton />
                </div>

                <div className="flex flex-col items-center p-2">
                    <span className="border w-0 h-24"></span>
                    <span className="text-gray-400">OR</span>
                    <span className="border w-0 h-24"></span>
                </div>

                <div className="w-2/4 flex justify-center items-center py-6">
                    <div>
                        <p className="text-xs text-center text-gray-500 mb-2 font-semibold">Pay with UPI ID</p>

                        <div className="border border-primary-light h-40 w-40"></div>
                    </div>
                </div>

            </div>

            {/* UPI Payment Gateway Icons */}
            <div className="flex justify-center gap-5 items-center mt-5">
                <Gpay />
                <Phonepay />
                <PayTM />
                <UPIPay />
            </div>
        </div>

    )
}

export default UPIPayment;